/* fa-market-split: tekst, prijzen en badges buiten de thuismarkt.
   Gegenereerd uit src/lib/storefront/market-split.ts — niet met de hand
   bijwerken, de installer overschrijft dit bestand. */
(function () {
  var C = window.FA_MARKET || {};

  var PH = (C.ph || []).slice().sort(function (a, b) { return b[0].length - a[0].length; });
  var DISC = typeof C.disc === 'number' ? C.disc : 0.1;
  var PCT = Math.round(DISC * 100);

  function phrase(t) {
    var out = t, i;
    for (i = 0; i < PH.length; i++) {
      if (!PH[i][0]) { continue; }
      out = out.split(PH[i][0]).join(PH[i][1]);
    }
    return out;
  }

  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, CODE: 1 };
  function swapText(root) {
    if (!root || !PH.length) { return; }
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node, next;
    while ((node = walker.nextNode())) {
      var p = node.parentNode;
      if (!p || SKIP[p.nodeName]) { continue; }
      next = phrase(node.nodeValue);
      if (next !== node.nodeValue) { node.nodeValue = next; }
    }
    /* Ook attributen die tekst dragen: alt, title, aria-label, placeholder. */
    var attrs = ['alt', 'title', 'aria-label', 'placeholder'];
    var els = root.querySelectorAll ? root.querySelectorAll('[alt],[title],[aria-label],[placeholder]') : [];
    for (var i = 0; i < els.length; i++) {
      for (var a = 0; a < attrs.length; a++) {
        var v = els[i].getAttribute(attrs[a]);
        if (v == null) { continue; }
        var nv = phrase(v);
        if (nv !== v) { els[i].setAttribute(attrs[a], nv); }
      }
    }
  }

  function parseMoney(text) {
    var m = String(text || '').match(/\d[\d.,\s\u00a0]*/);
    if (!m) { return null; }
    var raw = m[0].replace(/[\s\u00a0]/g, '');
    var dec = raw.match(/[.,](\d{2})$/);
    var norm = dec
      ? raw.slice(0, raw.length - 3).replace(/[.,]/g, '') + '.' + dec[1]
      : raw.replace(/[.,]/g, '');
    var n = Number(norm);
    return isFinite(n) ? n : null;
  }

  function formatLike(sample, value) {
    var m = String(sample || '').match(/\d[\d.,\s\u00a0]*/);
    if (!m || !isFinite(value)) { return sample; }
    var raw = m[0].replace(/[\s\u00a0.,]+$/, '');
    var before = sample.slice(0, m.index);
    var after = sample.slice(m.index + raw.length);
    var dec = raw.match(/[.,](\d{2})$/);
    /* Geen centen in het voorbeeld ("Save $496") = geen centen in de uitkomst;
       een scheider vóór precies drie cijfers is dan een duizendtal. */
    if (!dec) {
      var tm = raw.match(/[.,](?=\d{3}$)/);
      var whole = String(Math.round(value));
      if (tm) { whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, tm[0]); }
      return before + whole + after;
    }
    var decSep = dec[0].charAt(0);
    var thou = raw.indexOf('.') > -1 && decSep === ',' ? '.' : (raw.indexOf(',') > -1 && decSep === '.' ? ',' : '');
    var fixed = value.toFixed(2).split('.');
    var int = fixed[0];
    if (thou) { int = int.replace(/\B(?=(\d{3})+(?!\d))/g, thou); }
    return before + int + decSep + fixed[1] + after;
  }

  function anchorFor(price) {
    if (!(price > 0) || !(DISC > 0) || DISC >= 1) { return null; }
    /* Hele euro min vijf cent, niet een heel vijftal: bij 10% is een stap van
       vijf euro tot 8 procentpunt waard en dan liegt de badge ernaast. */
    var a = Math.round(Math.round(price / (1 - DISC) + 0.05) * 100 - 5) / 100;
    return a > price ? a : null;
  }

  function pctFor(price, anchor) {
    if (!(anchor > price) || !(anchor > 0)) { return null; }
    return Math.round((anchor - price) * 100 / anchor);
  }

  /* De doorgestreepte prijs is NIET altijd een del.
     Gemeten op het casa-thema van Perla (2026-09-03): de collectiekaart zet
     hem in een s, de plakbalk in een s naast een strong, de zoeksuggestie in
     twee spans zonder enige semantiek. Alleen op del/ins matchen liet dus
     precies de collectiepagina — de belangrijkste kaart van de winkel — op
     70% staan terwijl de badge ernaast al 10% zei. Vandaar een bredere
     herkenning: doorgestreept OF een klasse die "compare" draagt.
     Motion (Jack Reid, 2026-09-05) noemt hem op de kaart
     grid-product__price--original: geen del, geen "compare", dus ook
     "original" telt; de productpagina daar zegt wél product__price--compare.
     (Dit blok is een template-literal: geen backticks in commentaar.) */
  var CMP_SEL = 'del, s, strike, [class*="compare"], [class*="original"]';

  function compareEl(b) {
    var el = b.querySelector(CMP_SEL);
    /* Een verborgen compare-at hoort bij een product ZONDER korting (de quick
       add hergebruikt hetzelfde blok voor elk product). Daar valt niets te
       herschrijven, en de oude waarde die er nog in staat is niet van dit
       product. */
    if (el && el.hasAttribute && el.hasAttribute('hidden')) { return null; }
    return el;
  }

  /* De verkoopprijs: een ins als die er is, anders de eerste bladknoop met een
     bedrag dat LAGER ligt dan de doorgestreepte prijs. Die ondergrens is wat
     "Ahorra 70%" en "-70%" binnen hetzelfde blok buiten de deur houdt — die
     lezen als het getal 70 en zouden anders als prijs doorgaan. */
  function saleEl(b, cmp) {
    var ins = b.querySelector('ins');
    if (ins && ins !== cmp) { return ins; }
    var cmpVal = parseMoney(cmp.textContent);
    if (!(cmpVal > 0)) { return null; }
    var all = b.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el === cmp || cmp.contains(el) || el.contains(cmp)) { continue; }
      if (el.children.length) { continue; }
      var v = parseMoney(el.textContent);
      if (v != null && v > 0 && v < cmpVal) { return el; }
    }
    /* Sanibel-thema (Bruny, 2026-09-19): de kaart zet de verkoopprijs als KALE
       TEKSTKNOOP naast de doorgestreepte span, dus er is geen element om te
       vinden en de lus hierboven komt leeg terug. Dan blijft de kaart op 55%
       staan en laat fixBadges de badge ernaast met rust (blok zonder stempel).
       Vandaar een tweede ronde over de directe tekstknopen van het blok zelf;
       textContent werkt op een tekstknoop net zo, dus de aanroeper merkt het
       verschil niet. */
    var kids = b.childNodes;
    for (var k = 0; k < kids.length; k++) {
      if (kids[k].nodeType !== 3) { continue; }
      var tv = parseMoney(kids[k].nodeValue);
      if (tv != null && tv > 0 && tv < cmpVal) { return kids[k]; }
    }
    return null;
  }

  /* Zonder doorgestreepte prijs is er niets te herschrijven: het product staat
     niet in de sale en dat verandert buiten de markt niet.

     SCHRIJVEN ALS HET VERSCHILT, geen eenmalige vlag. De productpagina tekent
     zijn eigen prijs en spaarbadge opnieuw bij elke variantwissel, en met een
     "al gedaan"-vlag stond er daarna weer 70%. Doordat het anker uit de prijs
     wordt afgeleid, levert een tweede ronde exact dezelfde tekst op en stopt
     de mutatielus vanzelf. */
  function fixPrices(root) {
    var sel = (C.price || []).join(',');
    if (!sel) { return; }
    var blocks = root.querySelectorAll(sel);
    for (var i = 0; i < blocks.length; i++) {
      var b = blocks[i];
      var cmp = compareEl(b);
      if (!cmp) { continue; }
      var now = saleEl(b, cmp);
      if (!now) { continue; }
      var price = parseMoney(now.textContent);
      /* Het anker wordt uit de PRIJS afgeleid, dus een al herschreven blok
         geeft hetzelfde antwoord. */
      var anchor = anchorFor(price);
      if (anchor == null) { continue; }
      var want = formatLike(cmp.textContent, anchor);
      if (cmp.textContent !== want) { cmp.textContent = want; }
      b.setAttribute('data-fa-mkt-price', String(anchor));
      b.setAttribute('data-fa-mkt-paid', String(price));
      var pct = pctFor(price, anchor);
      if (pct != null) { b.setAttribute('data-fa-mkt-pct', String(pct)); }
    }
  }

  /* De badge hoort bij de kaart, dus zowel het bedrag ALS het percentage komen
     uit het prijsblok ernaast — dat is het paar dat de bezoeker ziet staan.
     Alleen als er geen blok te vinden is, valt het terug op de ingestelde
     korting; beter een badge die iets zegt dan een die 70% blijft beweren.
     Ook hier: schrijven als het verschilt, geen vlag (zie fixPrices). */
  function fixBadges(root) {
    var sel = (C.badge || []).join(',');
    var psel = (C.price || []).join(',');
    if (!sel) { return; }
    var badges = root.querySelectorAll(sel);
    for (var i = 0; i < badges.length; i++) {
      var el = badges[i];
      /* De zoektocht begint bij de badge ZELF, niet bij zijn ouder: de
         kortingspil van de quick add staat IN het prijsblok, en een blok is
         geen afstammeling van zichzelf. */
      var block = null, node = el, hops = 0;
      while (node && !block && hops < 8) {
        if (psel) {
          block = node.matches && node.matches(psel) ? node : node.querySelector(psel);
        }
        node = node.parentElement;
        hops++;
      }
      var anchor = block ? Number(block.getAttribute('data-fa-mkt-price')) : NaN;
      var paid = block ? Number(block.getAttribute('data-fa-mkt-paid')) : NaN;
      var pctAttr = block ? block.getAttribute('data-fa-mkt-pct') : null;
      /* Een blok ZONDER stempel is er een die fixPrices bewust oversloeg: geen
         doorgestreepte prijs, of een verborgen compare-at van het vorige
         product. De badge ernaast hoort dan met rust gelaten te worden — hem
         toch op de ingestelde korting zetten verzint een aanbieding die het
         product niet heeft. De terugval hieronder geldt alleen voor een badge
         waar helemaal geen prijsblok bij te vinden was. */
      if (block && pctAttr == null) { continue; }
      var txt = el.textContent || '';
      var want = txt;
      if (/%/.test(txt)) {
        var shown = pctAttr == null ? PCT : Number(pctAttr);
        if (!isFinite(shown)) { shown = PCT; }
        want = txt.replace(/\d+(?=\s*%)/, String(shown));
      } else {
        if (!isFinite(anchor) || !isFinite(paid)) { continue; }
        want = formatLike(txt, Math.round((anchor - paid) * 100) / 100);
      }
      if (want !== txt) { el.textContent = want; }
    }
  }

  function reveal(root) {
    var els = root.querySelectorAll('.fa-mkt-swap');
    for (var i = 0; i < els.length; i++) { els[i].setAttribute('data-fa-mkt-done', '1'); }
  }

  function pass(root) {
    /* Volgorde: eerst de prijzen (die lezen cijfers), dan de badges (die
       lezen het prijsblok), dan pas de tekst — anders verandert een
       woordvervanging de string waar het bedrag nog uit gelezen moest. */
    try { fixPrices(root); } catch (e) { }
    try { fixBadges(root); } catch (e2) { }
    try { swapText(root); } catch (e3) { }
    try { reveal(root); } catch (e4) { }
    /* De tabtitel staat in de head en valt dus buiten de tekstloop; een
       collectie die "Anniversary Sale" heet zou anders in het tabblad zo
       blijven heten terwijl de pagina eronder al is omgezet. */
    try {
      if (PH.length && document.title) {
        var nt = phrase(document.title);
        if (nt !== document.title) { document.title = nt; }
      }
    } catch (e5) { }
  }

  function run() { pass(document.body || document.documentElement); }

  function start() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    watch();
  }

  /* ── land vaststellen ──────────────────────────────────────────────────
     Is de klasse al gezet, dan wist de inline classifier het land uit de
     cache en is er niets meer op te halen. Staat er 'pending', dan is dit het
     allereerste bezoek: één opzoeking, het antwoord in de cache, en pas dan
     het beeld omzetten. Mislukt de opzoeking, dan blijft het thuisbeeld staan
     — dat is de veilige kant. */
  var root = document.documentElement;
  if (window.FA_MARKET_VIEW === 'intl') { start(); return; }
  if (window.FA_MARKET_VIEW === 'home') { return; }
  if (root.className.indexOf('fa-mkt-pending') === -1) { return; }
  if (!C.on || !C.geo) { settle('home'); return; }

  function settle(view) {
    window.FA_MARKET_VIEW = view;
    /* Zonder regex, en dat is met opzet. Dit stond er als
       .replace(/\bfa-mkt-pending\b/, '').replace(/\s+$/, ''), en in een
       template-literal is \b het BACKSPACE-teken en \s de letter s: de eerste
       vervanging matchte nooit (pending bleef naast intl staan) en de tweede
       knipte een afsluitende "s" van de laatste klasse. Klassen zijn met
       spaties gescheiden, dus split doet het werk en kan niet zo stukgaan. */
    var parts = root.className.split(' '), keep = [], i;
    for (i = 0; i < parts.length; i++) {
      if (parts[i] && parts[i] !== 'fa-mkt-pending') { keep.push(parts[i]); }
    }
    keep.push('fa-mkt-' + view);
    root.className = keep.join(' ');
    if (view === 'intl') { start(); }
  }

  try {
    fetch(C.geo, { credentials: 'omit', mode: 'cors' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var country = j && j.country ? String(j.country).toUpperCase() : null;
        if (country) {
          try {
            localStorage.setItem(
              window.FA_MARKET_GEO_KEY || 'fa_market_geo',
              JSON.stringify({ c: country, at: Date.now() }),
            );
          } catch (e) { }
        }
        var decide = window.FA_MARKET_DECIDE;
        settle(decide ? decide(country) : 'home');
      })
      .catch(function () { settle('home'); });
  } catch (e) { settle('home'); }

  /* Quick add, de cart drawer en oneindig scrollen tekenen na het laden.
     Een observer met een korte samenvoeging is goedkoper dan een interval en
     mist niets: alles wat bijkomt, komt als mutatie langs. */
  var queued = null;
  function watch() {
    try {
      new MutationObserver(function () {
        if (queued) { return; }
        queued = setTimeout(function () { queued = null; run(); }, 60);
      }).observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) { }
  }
})();